import Env from "../env/Env";
import createAxiosInstance from "../utils/axiosInstance";
import { defaultAPIsResponseType, defaultGraphsGetFiltersType } from "../consts/shared";

const basePath = '/api/graphs/dashboard-3';
const request = createAxiosInstance(`${Env.API_BASE}${basePath}`);

const dashboard3APIsService = {
  basePath,
  fetchCourseCompletionData: (params: defaultGraphsGetFiltersType, signal?: AbortSignal): Promise<defaultAPIsResponseType> => {
    return new Promise((resolve, reject) => {
      request
        .get("/course-completion", { params, signal })
        .then(({ data }) => {
          resolve({ ...data, ...params });
        })
        .catch((err) => {
          reject(err?.response?.data?.errors || []);
        });
    });
  },
  /*fetchUsersByCourseCompletionData: (params: defaultGraphsGetFiltersType, signal?: AbortSignal): Promise<defaultAPIsResponseType> => {
    return new Promise((resolve, reject) => {
      request
        .get("/users-by-course-completion", { params, signal })
        .then(({ data }) => {
          resolve({ ...data, ...params });
        })
        .catch((err) => {
          reject(err?.response?.data?.errors || []);
        });
    });
  },
  fetchNumberOfCompletedCoursesData: (params: defaultGraphsGetFiltersType, signal?: AbortSignal): Promise<defaultAPIsResponseType> => {
    return new Promise((resolve, reject) => {
      request
        .get("/number-of-completed-courses", { params, signal })
        .then(({ data }) => {
          resolve({ ...data, ...params });
        })
        .catch((err) => {
          reject(err?.response?.data?.errors || []);
        });
    });
  },
  fetchNumberOfIncompleteCoursesData: (params: defaultGraphsGetFiltersType, signal?: AbortSignal): Promise<defaultAPIsResponseType> => {
    return new Promise((resolve, reject) => {
      request
      .get("/number-of-incomplete-courses", { params, signal })
        .then(({ data }) => {
          resolve({ ...data, ...params });
        })
        .catch((err) => {
          reject(err?.response?.data?.errors || []);
        });
    });
  },*/
  fetchOrganisationsWithWithoutCoursesData: (params: defaultGraphsGetFiltersType, signal?: AbortSignal): Promise<defaultAPIsResponseType> => {
    return new Promise((resolve, reject) => {
      request
        .get("/organisations-with-without-courses", { params, signal })
        .then(({ data }) => {
          resolve({ ...data, ...params });
        })
        .catch((err) => {
          reject(err?.response?.data?.errors || []);
        });
    });
  },
  
  fetchOrganisationsWithCoursesData: (params: defaultGraphsGetFiltersType, signal?: AbortSignal): Promise<defaultAPIsResponseType> => {
    return new Promise((resolve, reject) => {
      request
        .get("/organisations-with-courses", { params, signal })
        .then(({ data }) => {
          resolve({ ...data, ...params });
        })
        .catch((err) => {
          reject(err?.response?.data?.errors || []);
        });
    });
  },
  fetchOrganisationsWithoutCoursesData: (params: defaultGraphsGetFiltersType, signal?: AbortSignal): Promise<defaultAPIsResponseType> => {
    return new Promise((resolve, reject) => {
      request
        .get("/organisations-without-courses", { params, signal })
        .then(({ data }) => {
          resolve({ ...data, ...params });
        })
        .catch((err) => {
          reject(err?.response?.data?.errors || []);
        });
    });
  },
  fetchCourseBreakdownData: (params: defaultGraphsGetFiltersType, signal?: AbortSignal): Promise<defaultAPIsResponseType> => {
    return new Promise((resolve, reject) => {
      request
        .get("/course-breakdown", { params, signal })
        .then(({ data }) => {
          resolve({ ...data, ...params });
        })
        .catch((err) => {
          reject(err?.response?.data?.errors || []);
        });
    });
  },
  fetchCoursesBreakdownDrillDownData: (params: defaultGraphsGetFiltersType, signal?: AbortSignal): Promise<defaultAPIsResponseType> => {
    return new Promise((resolve, reject) => {
      request
        .get("/courses-breakdown-drill-down", { params, signal })
        .then(({ data }) => {
          resolve({ ...data, ...params });
        })
        .catch((err) => {
          reject(err?.response?.data?.errors || []);
        });
    });
  },
  fetchCoursesBreakdownDrillDownDataV2: (params: defaultGraphsGetFiltersType, signal?: AbortSignal): Promise<defaultAPIsResponseType> => {
    return new Promise((resolve, reject) => {
      request
        .get("/courses-breakdown-drill-down-v2", { params, signal })
        .then(({ data }) => {
          resolve({ ...data, ...params });
        })
        .catch((err) => {
          reject(err?.response?.data?.errors || []);
        });
    });
  },
  fetchDrillDownSubData: (params: { parentId: number; parentType: 'Course' | 'Organisation' } & defaultGraphsGetFiltersType, signal?: AbortSignal): Promise<defaultAPIsResponseType> => {
    return new Promise((resolve, reject) => {
      request
        .get("/drill-down-sub-data", { params, signal })
        .then(({ data }) => {
          resolve({ ...data, ...params });
        })
        .catch((err) => {
          reject(err?.response?.data?.errors || []);
        });
    });
  },
  fetchCourseOverviewTrendData: (params: defaultGraphsGetFiltersType, signal?: AbortSignal): Promise<defaultAPIsResponseType> => {
    return new Promise((resolve, reject) => {
      request
        .get("/course-overview-trend", { params, signal })
        .then(({ data }) => {
          resolve({ ...data, ...params });
        })
        .catch((err) => {
          reject(err?.response?.data?.errors || []);
        });
    });
  },
  fetchCourseCompletionByMonthData: (params: defaultGraphsGetFiltersType, signal?: AbortSignal): Promise<defaultAPIsResponseType> => {
    return new Promise((resolve, reject) => {
      request
        .get("/course-completion-by-month", { params, signal })
        .then(({ data }) => {
          resolve({ ...data, ...params });
        })
        .catch((err) => {
          reject(err?.response?.data?.errors || []);
        });
    });
  },
  fetchSummaryCardsData: (params: defaultGraphsGetFiltersType, signal?: AbortSignal): Promise<defaultAPIsResponseType> => {
    return new Promise((resolve, reject) => {
      request
        .get("/summary-cards", { params, signal })
        .then(({ data }) => {
          resolve({ ...data, ...params });
        })
        .catch((err) => {
          reject(err?.response?.data?.errors || []);
        });
    });
  },
};

export default dashboard3APIsService;
